(function () {
  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function enhanceProductHighlights(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll
      ? scope.querySelectorAll('.cdf-description, .product-description')
      : [];

    containers.forEach(function (container) {
      container.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong,b').forEach(function (heading) {
        if (normalize(heading.textContent) !== 'product highlights') return;

        var box = heading.parentElement;
        if (!box) return;

        if ((heading.tagName === 'STRONG' || heading.tagName === 'B') && box.tagName === 'P' && box.parentElement) {
          heading = box;
          box = box.parentElement;
        }

        if (box === container && heading.parentElement) {
          box = heading.parentElement;
        }

        box.classList.add('ft-product-highlights');
        heading.classList.add('ft-product-highlights-title');
      });
    });
  }

  function run() {
    enhanceProductHighlights(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceProductHighlights(event.target || document);
  });
})();